import http from './httpService'

const LoginService = {
    loginUser (loginDto) {
        return http.post('/login', loginDto)
    },
}

export default LoginService
